import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Header from '../../../components/Header';
import { Wrapper, MainContent } from './styles';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
}));

const DefaultLayout: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <Wrapper>
      <Header />
      <MainContent>
        <div className={classes.appBarSpacer} />
        {children}
      </MainContent>
    </Wrapper>
  );
};

export default DefaultLayout;
